var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns is-centered" }, [
    _c(
      "div",
      { staticClass: "column is-6-desktop is-12-mobile is-12-tablet" },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        !_vm.customer.firstName ||
        !_vm.customer.lastName ||
        _vm.hasNewCustomerName(_vm.customer.firstName, _vm.customer.lastName)
          ? _c("div", { staticClass: "field space-bottom" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.fullName,
                      expression: "fullName"
                    }
                  ],
                  staticClass: "input text-input",
                  attrs: {
                    autofocus: "",
                    type: "text",
                    placeholder: "First & Last Name"
                  },
                  domProps: { value: _vm.fullName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.fullName = $event.target.value
                    }
                  }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.customer.email
          ? _c("div", { staticClass: "field space-bottom" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "input text-input",
                  attrs: { autofocus: "", type: "text", placeholder: "Email" },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-column control-group" },
          [
            [
              _c("div", { staticClass: "flex-full-width" }, [
                _c(
                  "label",
                  { staticClass: "control control--checkbox cust-radio" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.receiveOffers,
                          expression: "receiveOffers"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.receiveOffers)
                          ? _vm._i(_vm.receiveOffers, null) > -1
                          : _vm.receiveOffers
                      },
                      on: {
                        click: function($event) {
                          _vm.receiveOffers = !_vm.receiveOffers
                        },
                        change: function($event) {
                          var $$a = _vm.receiveOffers,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.receiveOffers = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.receiveOffers = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.receiveOffers = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "control__indicator checkbox" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Receive Email Offers")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7 has-text-grey-light" }, [
                      _vm._v(
                        "can be turned " +
                          _vm._s(_vm.receiveOffers ? "off" : "on") +
                          " at any time from your profile"
                      )
                    ])
                  ]
                )
              ])
            ]
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "has-text-centered space-bottom" },
          [
            _c("BaseButton", {
              attrs: {
                title: "Start Ordering",
                classNames: ["button--modifier"]
              },
              nativeOn: {
                click: function($event) {
                  return _vm.submitRequest($event)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.errMsgs.length
          ? _c("p", [_vm._v("Error: " + _vm._s(_vm.errMsgs.join(", ")))])
          : _vm._e(),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.msg))])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "has-text-centered" }, [
      _c("p", { staticClass: "is-size-1" }, [_vm._v("👏")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field has-text-centered" }, [
      _c("label", { staticClass: "label is-size-4 heading-txt" }, [
        _c("b", [
          _vm._v("Congratulations!"),
          _c("br"),
          _vm._v(" We just need a bit more information")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-406534a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-406534a8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/LinkUser.vue
// module id = null
// module chunks = 